import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Button,
  IconButton,
} from '@mui/material';
import { Close } from '@mui/icons-material';
import { CashoutMarket, RiskRow } from '../../hooks/useCashoutLogic';

type TurboCashoutDialogProps = {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  loading: boolean;
  market: CashoutMarket | null;
  getTurboCashoutData: (market: CashoutMarket, exposureMap: Record<string, RiskRow[]>) => {
    runnerA: { name: string; risk: number };
    runnerB: { name: string; risk: number };
    turboCashoutAmount: number;
  } | null;
  exposureMaps: Record<string, RiskRow[]>;
  turboCashoutCommission: number;
};

const TurboCashoutDialog: React.FC<TurboCashoutDialogProps> = ({
  open,
  onClose,
  onConfirm,
  loading,
  market,
  getTurboCashoutData,
  exposureMaps,
  turboCashoutCommission,
}) => {
  const turboData = market ? getTurboCashoutData(market, exposureMaps) : null;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      className="stl-dialog rules-dialog"
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle className="stl-dialog-title">
        <div className="title-close-icon">
          <div className="modal-title notification-title">
            Turbo Cashout
          </div>
          <IconButton
            className="close-btn"
            onClick={onClose}
            disabled={loading}
          >
            <Close className="close-icon" />
          </IconButton>
        </div>
      </DialogTitle>
      <DialogContent className="stl-dialog-content">
        <div className="py-3">
          {turboData ? (
            <>
              {/* Risk Display Section */}
              <div className="flex items-center justify-between mb-3 p-3 bg-white bg-opacity-10 rounded-lg">
                <div className="flex-1 text-center">
                  <div className="text-sm font-medium text-white mb-1">
                    {turboData.runnerA.name}
                  </div>
                  <div className="text-lg font-semibold text-green-400">
                    {Number(turboData.runnerA.risk).toFixed(2)}
                  </div>
                </div>
                <div className="w-px h-8 bg-white bg-opacity-30 mx-3"></div>
                <div className="flex-1 text-center">
                  <div className="text-sm font-medium text-white mb-1">
                    {turboData.runnerB.name}
                  </div>
                  <div className="text-lg font-semibold text-green-400">
                    {Number(turboData.runnerB.risk).toFixed(2)}
                  </div>
                </div>
              </div>

              {/* Fee Notice */}
              <div className="text-center text-sm px-3 pt-2 rounded text-[var(--ion-color-danger)]">
                We are deducting {turboCashoutCommission}% fee on cashout amount.
              </div>

              {/* Confirmation Text */}
              <div className="text-base text-white text-center pt-2">
                Do you wish to perform turbo cashout?
              </div>
            </>
          ) : (
            <div className="text-white text-center py-3">
              No risk data available
            </div>
          )}
        </div>
      </DialogContent>
      <div className="px-4 pb-3 flex justify-center">
        <Button
          size="medium"
          variant="contained"
          onClick={onConfirm}
          disabled={loading}
          style={{
            backgroundColor: 'var(--ion-color-primary)',
            color: '#ffffff',
            minWidth: '120px'
          }}
        >
          {loading ? 'Processing...' : 'Turbo Cashout'}
        </Button>
      </div>
    </Dialog>
  );
};

export default TurboCashoutDialog;
